import { Component, Input, Inject } from '@angular/core';
import { SiteURLUtils } from '../../common/site.url.utils';
import { redirectToURL } from '../../common/common';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../../api/config';
import { Reservation } from '../../api/model/reservation/reservation.model';
import { Hotel } from '../../api/model/hotel/hotel.model';

@Component({
  selector: 'group-code',
  templateUrl: './group-code.component.html',
  styleUrls: ['./group-code.component.scss']
})
export class GroupCodeComponent {
  _reservation: Reservation;
  hasGroupCode: boolean;
  isRemoveMode: boolean;
  rate: any;
  groupCode: string;
  shouldDisplay: boolean;

  @Input() isOpen: boolean;
  @Input() messages;
  @Input() set reservation(reservation: Reservation) {
    this._reservation = reservation;
    this.setInfo();
  }
  @Input() hotel: Hotel;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) { }

  setInfo() {
    this.rate = this._reservation.rate;
    this.isRemoveMode = false;
    this.hasGroupCode = !!this.rate.groupCode;
    this.shouldDisplay = !this.rate.freeNight;
  }

  remove() {
    if (this.isRemoveMode) {
      redirectToURL(SiteURLUtils.getLocalizedChangeRoomUrl(this.appConfig, this._reservation, this.hotel, true));
    } else {
      this.isRemoveMode = true;
    }

  }

  cancelRemove() {
    this.isRemoveMode = false;
  }

  addGroupCode() {
    redirectToURL(SiteURLUtils.getLocalizedChangeRoomUrl(this.appConfig, this._reservation, this.hotel, false, this.groupCode));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/group-code/group-code.component.ts